import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { Typography } from 'app/shared/components/atoms';
import { MappingsProps } from 'app/fan/components/templates/EventPage/components/EventCharacteristicsList/utils';
import { ReactComponent as CommercialBuilding } from 'icons/building.svg';
import { ReactComponent as Residential } from 'icons/residential.svg';

export function useVenueTypeMappings({ formatMessage }: MappingsProps) {
  const { colors } = useCurrentTheme();
  const intlPrefix = 'event.eventCharacteristicsList.venueType';
  const id = 'venue_type';

  return {
    commercial: {
      id,
      title: formatMessage({ id: `${intlPrefix}.commercial` }),
      icon: CommercialBuilding,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.commercial.details` })}
        </Typography>
      ),
    },
    residential: {
      id,
      title: formatMessage({ id: `${intlPrefix}.residential` }),
      icon: Residential,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.residential.details` })}
        </Typography>
      ),
    },
  };
}
